import { Container, Row, Col, Card, Placeholder } from "react-bootstrap";

export default function DashboardSkeleton() {
  return (
    <Container fluid className="py-2">
      <h1 className="text-2xl fw-bolder my-4">Dashboard</h1>

      <Row className="g-3">
        <Col xs={12} md={9}>
          <Card className="p-4">
            <Placeholder as="h4" animation="glow">
              <Placeholder xs={6} />
            </Placeholder>
            <Placeholder animation="glow">
              <Placeholder xs={12} />
              <Placeholder xs={10} />
              <Placeholder xs={8} />
            </Placeholder>
          </Card>
        </Col>

        <Col xs={12} md={3}>
          <Card className="p-4">
            <Placeholder animation="glow">
              <Placeholder xs={12} />
              <Placeholder xs={8} />
            </Placeholder>
          </Card>
        </Col>

        <Col xs={12} md={6}>
          <Card className="p-4">
            <Placeholder animation="glow">
              <Placeholder xs={12} />
              <Placeholder xs={9} />
              <Placeholder xs={7} />
            </Placeholder>
          </Card>
        </Col>

        <Col xs={12} md={6}>
          <Card className="p-4">
            <Placeholder animation="glow">
              <Placeholder xs={12} />
              <Placeholder xs={10} />
              <Placeholder xs={6} />
            </Placeholder>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
